import type { ReactElement } from 'react';
import { TaxreturnAccountsbuilder } from './TaxreturnAccountsbuilder';
import { TaxreturnAdjustedtrialbalance } from './TaxreturnAdjustedtrialbalance';
import { TaxreturnImportexceptions } from './TaxreturnImportexceptions';
import { TaxreturnJournals } from './TaxreturnJournals';
import { TaxreturnNominalmapping } from './TaxreturnNominalmapping';
import { TaxreturnStatutorydatabase } from './TaxreturnStatutorydatabase';
import { TaxreturnValidationcentre } from './TaxreturnValidationcentre';
import { TaxreturnWorkingpapers } from './TaxreturnWorkingpapers';

/** Ported screens of this slice, keyed by their Angular URL (see src/app/routeManifest.ts). */
export const screens: Record<string, ReactElement> = {
  '/home/taxreturns/tasks-importexceptions': <TaxreturnImportexceptions />,
  '/home/taxreturns/tasks-nominalmapping': <TaxreturnNominalmapping />,
  '/home/taxreturns/tasks-adjustedtrialbalance': <TaxreturnAdjustedtrialbalance />,
  '/home/taxreturns/tasks-journals': <TaxreturnJournals />,
  '/home/taxreturns/working-papers': <TaxreturnWorkingpapers />,
  '/home/taxreturns/statutory-database': <TaxreturnStatutorydatabase />,
  '/home/taxreturns/accounts-builder': <TaxreturnAccountsbuilder />,
  '/home/taxreturns/validation-centre': <TaxreturnValidationcentre />,
};
